// extracted by mini-css-extract-plugin
module.exports = {"container":"aa07","titleBar":"e6e0","titleIcon":"_3b43","title":"_9173","list":"c5fc","image":"_9b60"};